import './customer.scss';

import { customers } from '../../../content';

export const Customers = () => {
  return (
    <section className="container">
      <div className="row gy-4 py-xl-2">
        <div className="col-md-4">
          <h2 className="mb-0 text-md-start text-center">Trusted by organizations across industries</h2>
        </div>
        <div className="col-lg-7 offset-lg-1 col-md-8">
          <div className="row row-cols-sm-3 row-cols-2 gy-4 logo-container">
            {customers.map((customer) => (
              <div className="col" key={customer.id}>
                <div className="position-relative text-center">
                  <img src={customer.logo} width="160" alt={customer.name} className="d-block mx-auto mb-3" />
                  <a
                    href={customer.url}
                    className="text-body justify-content-center fs-sm stretched-link text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {/* {customer.name} */}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
